// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Label = require("../../common/Components/Label.bs.js");
let Numeral = require("../../../utils/Numeral.bs.js");
let Scalars = require("../../../scalars/Scalars.bs.js");
let NumberUtils = require("../../common/NumberUtils.bs.js");
let Stdlib_List = require("@rescript/runtime/lib/js/Stdlib_List.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let PropertyPrice = require("../../common/Property/PropertyPrice.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let WizardFormUtils = require("../wizard/WizardFormUtils.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let PropertyAttributes = require("../../cap/Property/components/PropertyAttributes.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let DevelopmentSampleUnitType = require("../../common/Development/DevelopmentSampleUnitType.bs.js");
let DevelopmentUnitSearchResultCard = require("./DevelopmentUnitSearchResultCard.bs.js");
let DevelopmentUnitSearchResultAgent = require("./DevelopmentUnitSearchResultAgent.bs.js");
let DevelopmentUnitSearchResultActions = require("./DevelopmentUnitSearchResultActions.bs.js");
let DevelopmentUnitSearchResultTimestamp = require("./DevelopmentUnitSearchResultTimestamp.bs.js");
let DevelopmentUnitSearchResultTitleAndLocation = require("./DevelopmentUnitSearchResultTitleAndLocation.bs.js");
let DevelopmentUnitSearchResult_newDevelopmentUnit_graphql = require("../../../__generated__/DevelopmentUnitSearchResult_newDevelopmentUnit_graphql.bs.js");

function unitPropertyAttributes(beds, baths, squareFeet, unitType) {
  return Stdlib_List.filterMap({
    hd: Stdlib_Option.map(unitType, unitType => [
      DevelopmentSampleUnitType.label(unitType),
      "Empty"
    ]),
    tl: {
      hd: Stdlib_Option.map(beds, beds => [
        beds.toString(),
        beds === 1 ? "Bed" : "Beds"
      ]),
      tl: {
        hd: Stdlib_Option.map(baths, baths => [
          NumberUtils.formatFloat(baths),
          (baths | 0) === 1 ? "Bath" : "Baths"
        ]),
        tl: {
          hd: Stdlib_Option.map(squareFeet, squareFeet => [
            Numeral.formatNumber(squareFeet),
            "Sqft"
          ]),
          tl: /* [] */0
        }
      }
    }
  }, x => x);
}

function developmentSummaryText(developer, estimatedCompletion) {
  let values = Stdlib_Array.keepSome([
    WizardFormUtils.noneIfEmpty(developer),
    Stdlib_Option.map(estimatedCompletion, Scalars.Year.toString)
  ]);
  if (values.length !== 0) {
    return values.join(" • ");
  }
}

function DevelopmentUnitSearchResult$StatusLabel(props) {
  return JsxRuntime.jsx(Label.Info.make, {
    text: "Sample Unit"
  });
}

let StatusLabel = {
  make: DevelopmentUnitSearchResult$StatusLabel
};

let convertFragment = DevelopmentUnitSearchResult_newDevelopmentUnit_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, DevelopmentUnitSearchResult_newDevelopmentUnit_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(DevelopmentUnitSearchResult_newDevelopmentUnit_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, DevelopmentUnitSearchResult_newDevelopmentUnit_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(DevelopmentUnitSearchResult_newDevelopmentUnit_graphql.node, convertFragment, fRef);
}

let UnitFragment_newDevelopmentUnitType_decode = DevelopmentUnitSearchResult_newDevelopmentUnit_graphql.Utils.newDevelopmentUnitType_decode;

let UnitFragment_newDevelopmentUnitType_fromString = DevelopmentUnitSearchResult_newDevelopmentUnit_graphql.Utils.newDevelopmentUnitType_fromString;

let UnitFragment = {
  newDevelopmentUnitType_decode: UnitFragment_newDevelopmentUnitType_decode,
  newDevelopmentUnitType_fromString: UnitFragment_newDevelopmentUnitType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function DevelopmentUnitSearchResult(props) {
  let unit = RescriptRelay_Fragment.useFragment(DevelopmentUnitSearchResult_newDevelopmentUnit_graphql.node, convertFragment, props.unit);
  let propertyAttributes = unitPropertyAttributes(unit.beds, unit.baths, unit.squareFeet, unit.unitType);
  let summary = developmentSummaryText(unit.development.developer, unit.development.estimatedCompletion);
  let price = unit.price;
  return JsxRuntime.jsx(DevelopmentUnitSearchResultCard.make, {
    unit: unit.fragmentRefs,
    label: JsxRuntime.jsx(DevelopmentUnitSearchResult$StatusLabel, {}),
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx(DevelopmentUnitSearchResultTitleAndLocation.make, {
          unit: unit.fragmentRefs
        }),
        price !== undefined ? JsxRuntime.jsx(PropertyPrice.PriceInternal.PriceDisplay.make, {
            propertyPrice: price.fragmentRefs,
            size: "medium"
          }) : JsxRuntime.jsx("div", {
            children: "No price set",
            className: "text-lg font-medium text-gray-500"
          }),
        propertyAttributes !== 0 ? JsxRuntime.jsx(PropertyAttributes.make, {
            propertyAttributes: propertyAttributes,
            size: "sm"
          }) : null,
        summary !== undefined ? JsxRuntime.jsx("div", {
            children: summary,
            className: "text-sm text-zinc-600"
          }) : null,
        JsxRuntime.jsx(DevelopmentUnitSearchResultAgent.make, {
          unit: unit.fragmentRefs
        }),
        JsxRuntime.jsx(DevelopmentUnitSearchResultTimestamp.make, {
          unit: unit.fragmentRefs
        }),
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(DevelopmentUnitSearchResultActions.make, {
            unit: unit.fragmentRefs
          }),
          className: "mt-auto"
        })
      ],
      className: "flex h-full flex-col gap-4"
    })
  });
}

let Card;

let TitleAndLocation;

let Agent;

let Timestamp;

let Actions;

let make = DevelopmentUnitSearchResult;

exports.unitPropertyAttributes = unitPropertyAttributes;
exports.developmentSummaryText = developmentSummaryText;
exports.StatusLabel = StatusLabel;
exports.UnitFragment = UnitFragment;
exports.Card = Card;
exports.TitleAndLocation = TitleAndLocation;
exports.Agent = Agent;
exports.Timestamp = Timestamp;
exports.Actions = Actions;
exports.make = make;
/* Label Not a pure module */
